import React from 'react';
import { useCheckWidth } from '@milanlaser/mlcomponents';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import { useCallCenterHours } from '../../hooks/useCallCenterHours';
import { LinkToText } from '../../components/link-to-text/link-to-text';
import { SalesforceChat } from '../../components/salesforce-chat/SalesforceChat';

export function Chat() {
    const width = useCheckWidth();
    const { isDesktop } = useDeviceDetection();
    const { isTextChatAvailable } = useCallCenterHours();

    const isTextChatFeatureFlagEnabled = process.env.GATSBY_LINK_TO_TEXT === 'true';
    const isTextChatEnabled = isTextChatAvailable && isTextChatFeatureFlagEnabled;

    const isMobileOnly = width && width.isMobile && !isDesktop;

    // On mobile: show LinkToText if text chat is available, otherwise show SalesforceChat
    // On desktop: always show SalesforceChat
    if (isMobileOnly) {
        return isTextChatEnabled ? <LinkToText /> : <SalesforceChat />;
    }

    return <SalesforceChat />;
}
